import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash/debounce'
import styled from 'styled-components'
import Spinner from 'britive-design-system/core/components/spinner'
import Snackbar from 'britive-design-system/core/components/snackbar'
import Table from 'britive-design-system/core/components/table'
import Typography from 'britive-design-system/core/components/typography'
import Button from 'britive-design-system/core/components/button'
import ModalPopup from 'britive-design-system/core/components/modal-popup'

import { getPaginatedSubordinate } from 'action_creators/user'
import getTotalPageCount from 'utils/getTotalPageCount'

import './RegisterVerificationDevice.scss'
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .cell-with-icon {
    display: flex;
    justify-content: space-between;
    .cell-icon {
      cursor: pointer;
    }
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const SubordinatesList = ({
  id,
  open,
  onClose,
  showSearch = false,
  name,
}) => {
  if (!open) return null

  const {
    paginatedSubordinate = {},
    fetchingPaginatedSubordinate,
    error: userError,
  } = useSelector(state => state.admin)

  const dispatch = useDispatch()

  const membersHelper = {
    fetching: fetchingPaginatedSubordinate,
    fetched: fetchingPaginatedSubordinate,
    error: userError,
    fetchData: params =>
      dispatch(
        getPaginatedSubordinate(id, params, paginatedSubordinate?.searchText)
      ),
    getData: () => paginatedSubordinate?.data || [],
    paginatedData: paginatedSubordinate || {},
    filterData: (data, value) => {
      return data.filter(({ name }) =>
        name.toLowerCase().includes(value.toLowerCase())
      )
    },
    columns: [
      {
        headerName: 'Name',
        width: 100,
        renderColumn: row => (
          <div className="table-cell">{row?.firstName + ' ' + row?.lastName}</div>
        ),
      },
    ],
  }

  const {
    fetching,
    error,
    fetchData,
    getData,
    columns,
    paginatedData,
  } = membersHelper

  useEffect(() => {
    fetchData({
      page: 0,
      size: 100,
    })
  }, [])

  const data = useMemo(() => getData(), [paginatedSubordinate?.data])

  const handleLoadMore = () => {
    fetchData({
      page: paginatedData?.page + 1,
      size: 100,
    })
  }

  const handleSearch = value => {
    fetchData({
      page: 0,
      size: 100,
      searchText: value?.length ? value : '',
    })
  }

  const tableProps = {
    rows: data,
    columns,
    resizableColumns: true,
    ...(showSearch && {
      searchBar: {
        onSearch: debounce(handleSearch, 300),
        placeholder: 'Search',
      },
    }),
    allowRowSelect: false,
  }
  return (
    <ModalPopup
      width={570}
      title={`Direct Reports for ${name ? `${name}` : ''}`}
      onCancel={onClose}
    >
      <Container>
        {fetching && <Spinner size={'medium'} message="Loading..." overlay />}
        {error && (
          <Snackbar errorList={[`Something went wrong while fetching users!`]} />
        )}
        {
          <>
            <Table {...tableProps} />
            {!data.length && !fetching && (
              <Typography variant="heading6">No data found!</Typography>
            )}
            {!fetching &&
              data?.length > 0 &&
              paginatedData?.page <
                getTotalPageCount(paginatedData?.count, paginatedData?.size) && (
                <ButtonContainer>
                  <Button variant="textOnly" size="medium" onClick={handleLoadMore}>
                    Load More
                  </Button>
                </ButtonContainer>
              )}
          </>
        }
      </Container>
    </ModalPopup>
  )
}
